export function isObject(something) {
    return (something !== null) && (typeof something === 'object');
}

